// extracted by mini-css-extract-plugin
export var promotionLink = "_vh-0";